import { Component, OnInit } from '@angular/core';
import { PassDataService } from '../../services/pass-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'header-cmp',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  totalSlokaTypes: string = '0';
  totalSlokas: string = '0';
  totalUsers: string = '0';
  totalBooks: string = "0";
  totalEvents: string = "0";
  totalBlogPosts: string = "0";

  menu = [
    {
      title: 'SlokaTypes',
      route: '/page/sloka-types-list',
      total: this.totalSlokaTypes,
    },
    {
      title: 'Slokas',
      route: '/page/slokas-list',
      total: this.totalSlokas,
    },
    {
      title: 'Users',
      route: '/page/users',
      total: this.totalUsers,
    },
    {
      title: 'Books',
      route: '/page/books-list',
      total: this.totalBooks,
    },
    {
      title: 'Events',
      route: '/page/events-list',
      total: this.totalEvents,
    },
    {
      title: 'Blog Posts',
      route: '/page/blog-post-list',
      total: this.totalBlogPosts,
    },
  ];

  activeTitle: string = this.menu[0].title;
  constructor(private passDataService: PassDataService, private router: Router) {}

  ngOnInit(): void {

    this.passDataService
    .getAllSlokaTypes()
    .subscribe((v) => (this.menu[0].total = v.length.toString()));

    this.passDataService
    .getAllSlokas()
    .subscribe((v) => (this.menu[1].total = v.length.toString()));

    this.passDataService
    .getAllUsers()
    .subscribe((v) => (this.menu[2].total = v.length.toString()));

    this.passDataService
    .getAllBooks()
    .subscribe((v) => (this.menu[3].total = v.length.toString()));

    this.passDataService
    .getAllEvents()
    .subscribe((v) => (this.menu[4].total = v.length.toString()));

    this.passDataService
    .getAllBlogPosts()
    .subscribe((v) => (this.menu[5].total = v.length.toString()));

    this.passDataService
    .getActivatedTitle()
    .subscribe((v) => (this.activeTitle = this.menu[0].title));
  }

  onTitleClick(i: number) {
    this.activeTitle = this.menu[i].title;
  }

  onOfferClick() {
    this.activeTitle = 'offer';
  }

  onProfileClick() {
    this.activeTitle = 'profile';
  }

  onLogoutClick() {
    this.activeTitle = 'logout';

    if (confirm('Are you sure to logout?')) {
      this.router.navigate(['/login']);
      localStorage.setItem("user","");
      localStorage.setItem("email","");
      localStorage.setItem("email","");
    } else {

    }
  }
}
